function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var IS_OPENED_CLASS = 'is-opened';
var ARIA_EXPANDED = 'aria-expanded';
var DROPDOWNS = '[data-component="documentEditDropdown"]';
var DROPDOWN_CTA = '[data-element="documentEditDropdownCta"]';
var TABLE_HOLDER = '[data-element="tableHolder"]';
var DocumentEditDropdown = /*#__PURE__*/function () {
  function DocumentEditDropdown(component) {
    var _this = this;
    _classCallCheck(this, DocumentEditDropdown);
    this.component = component;
    this.btn = this.component.querySelector('[data-element="documentEditDropdownBtn"]');
    this.formDelete = this.component.querySelector('[data-form="delete"]');
    this.btn.addEventListener('click', function () {
      return _this.toggle(_this.btn);
    });
    this.formDelete.addEventListener('submit', this.deleteFile.bind(this));
  }
  return _createClass(DocumentEditDropdown, [{
    key: "deleteFile",
    value: function deleteFile(e) {
      e.preventDefault();
      var target = e.target;
      var fileId = target.querySelector(DROPDOWN_CTA).dataset.fileId;
      target.closest(TABLE_HOLDER).classList.add('is-loading');
      fetch('/actions/nlr/my-documents/file', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: "action=delete&fileId=".concat(fileId, "&").concat(window.csrfTokenName, "=").concat(window.csrfTokenValue)
      }).then(function (response) {
        if (response.ok) {
          target.closest(TABLE_HOLDER).classList.remove('is-loading');
          var rowsLen = target.closest('tbody').querySelectorAll('tr').length;
          if (rowsLen > 1) {
            target.closest('tr').remove();
          } else {
            target.closest('table').remove();
            document.querySelector(TABLE_HOLDER).innerHTML = "\n            <h2 class=\"u-mv-xxs-1\">Det er ingen filer lagret</h2>\n          ";
          }
        }
      })["catch"](function (error) {
        console.log(error);
      });
    }
  }, {
    key: "closeSiblings",
    value: function closeSiblings(currentDropdown) {
      Array.from(document.querySelectorAll(DROPDOWNS)).forEach(function (dropdown) {
        if (currentDropdown !== dropdown) {
          dropdown.classList.remove(IS_OPENED_CLASS);
        }
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.component.classList.remove(IS_OPENED_CLASS);
      this.btn.setAttribute(ARIA_EXPANDED, false);
    }
  }, {
    key: "open",
    value: function open(dropdown, btn) {
      dropdown.classList.add(IS_OPENED_CLASS);
      btn.setAttribute(ARIA_EXPANDED, true);
      this.closeSiblings(dropdown);
      document.body.addEventListener('click', function autoClose(event) {
        if (!event.target.closest('[data-component="documentEditDropdown"]')) {
          document.removeEventListener('click', autoClose);
          dropdown.classList.remove(IS_OPENED_CLASS);
          btn.setAttribute(ARIA_EXPANDED, false);
        }
      });
    }
  }, {
    key: "toggle",
    value: function toggle(btn) {
      var _this2 = this;
      var dropdown = btn.parentNode;
      var menu = btn.parentNode.querySelector('[data-element="documentEditDropdownMenu"]');
      if (dropdown.matches(".".concat(IS_OPENED_CLASS))) {
        this.close();
      } else {
        this.open(dropdown, btn);
        menu.addEventListener('click', function (event) {
          if (event.target.matches(DROPDOWN_CTA)) {
            _this2.close();
          }
        });
      }
    }
  }]);
}();
Array.from(document.querySelectorAll(DROPDOWNS)).forEach(function (dropdown) {
  new DocumentEditDropdown(dropdown);
});